import { __assign } from "tslib";
// DS: C35M
import React from 'react';
import classnames from 'classnames';
import Flex from '../../Flex';
import UserAvatar from '../../User/Avatar';
import UserLink from '../../User/Link';
import AuthorWatchButton from '../../Button/AuthorWatchButton';
import CloseButton from '../../Button/CloseButton';
import { IconSize } from '../../Icons/IconWrap';
import { BiEventType } from '../../biLogger/constants';
import s from './MobileSubmissionDetailsHeader.scss';
var MobileSubmissionDetailsHeader = function (_a) {
    var exitDuperbrowse = _a.exitDuperbrowse, currentItem = _a.currentItem, isOwner = _a.isOwner, parent = _a.parent, biData = _a.biData, _b = _a.isSticky, isSticky = _b === void 0 ? true : _b, isStuck = _a.isStuck;
    var author = currentItem === null || currentItem === void 0 ? void 0 : currentItem.author;
    return (React.createElement(Flex, { className: classnames(s['root'], isSticky && s['sticky'], isStuck && s['stuck']), alignItems: "center" },
        author && (React.createElement("div", { className: s['author'] },
            React.createElement(UserAvatar, { size: 32, user: author }),
            React.createElement("span", { className: s['author-username'] },
                React.createElement(UserLink, { user: author, className: s['author-userlink'] })))),
        !isOwner && author && (React.createElement(AuthorWatchButton, { author: author, className: s['watch-button'] })),
        parent && (React.createElement(CloseButton, { className: s['close'], iconSize: IconSize.MEDIUM, view: "b5-3", onClick: exitDuperbrowse, biData: __assign({ evid: BiEventType.BACK_TO_CLICK, link_url: parent.url, next_itemid: parent.itemId, next_typeid: parent.typeId }, biData) }))));
};
MobileSubmissionDetailsHeader.displayName = 'MobileSubmissionDetailsHeader';
export default MobileSubmissionDetailsHeader;
//# sourceMappingURL=MobileSubmissionDetailsHeader.js.map